// extracted by mini-css-extract-plugin
module.exports = {"mobile":"768px","tablet":"1024px","desktop":"1366px","yellow":"#f9f0dd","green2":"#b8cec9"};